import orderBy from 'lodash.orderby';

import { nullableNumericToNumericStringConverter } from '@/_schemas/generic';
import { strToStatus } from '@/_schemas/status-input';
import { sortByLatest } from '@/_shared';

import type { CompanyFormSchema, CompanyQuerySchema } from '../schemas';

export function clientQueryToForm(data: CompanyQuerySchema): CompanyFormSchema {
  const agreements = (data?.agreements ?? []).filter((a) => !a.parent_id);

  return {
    ...data,
    short_name: data.short_name || '',
    account_number: data?.account_number ?? -1,
    consumers: data.consumers ? `${data.consumers}` : '',
    zoom_meeting_code: data.zoom_meeting_code || '',
    status: strToStatus(data.status),
    year_established: data.year_established
      ? { name: `${data.year_established}`, value: `${data.year_established}` }
      : null,
    annual_meeting_month: data.annual_meeting_month
      ? { name: `${data.annual_meeting_month}`, value: `${data.annual_meeting_month}` }
      : null,
    contacts: orderBy(data.contacts ?? [], ['first_name']),
    domains: orderBy(data.domains ?? [], ['name']),
    phone_numbers: sortByLatest(data.phone_numbers ?? []),
    relationship_score: data.relationship_score ?? null,
    primary_contact: data.primary_contact ?? null,
    exempt: data.exempt ?? '',
    tax_id: data.tax_id ?? '',

    box: nullableNumericToNumericStringConverter(data.box),
    freshdesk: nullableNumericToNumericStringConverter(data.freshdesk),
    harvest: nullableNumericToNumericStringConverter(data.harvest),

    gnt_affiliations: data.all_gnt_affiliations ?? [],
    non_gnt_affiliations: data.all_non_gnt_affiliations ?? [],

    subsidiaries: data.subsidiaries ?? [],
    primary_subsidiaries: data.primary_subsidiaries ?? null,

    agreements: agreements,

    client_assigned_vendor_id: data.client_assigned_vendor_id ?? '',
    override_payable_name: data.override_payable_name ?? '',
  };
}
